module.exports = __webpack_public_path__ + "img/js8.fa578533.jpg";